<plyca-ui-scroll-panel [config]="{ styleClass: 'custombar1 scrollPanel height55vh' }">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <br /><br />
        Example<br /><br /><br /><br /><br /><br /><br /><br />
        Example<br /><br /><br /><br /><br /><br /><br /><br />
        Example<br /><br /><br /><br /><br /><br /><br /><br />
        Example<br /><br /><br /><br /><br /><br /><br /><br />
      </div>
    </div></div
></plyca-ui-scroll-panel>
